import strings from './i18n'
import images from './images'
const R = {
  strings,
  images,
}
export default R
